// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2o01W","icon":"styles_icon__2Nbfm"};